import { ToolTip } from "./ToolTip"

export const AcreageToolTip = () => {
  const text =
    "Total acres are calculated from your property boundary selection. It is normal for this to differ slightly from legal records."

  return <ToolTip aria-label={text}>{text}</ToolTip>
}
